export default __webpack_public_path__ + "static/media/logo-dark.aac8d973.png";